/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs as  } from "relay-runtime";
export type WebhookEndpointRow_webhookEndpoint = {
    readonly id: string;
    readonly enabled: boolean;
    readonly url: string;
    readonly " $refType": "WebhookEndpointRow_webhookEndpoint";
};
export type WebhookEndpointRow_webhookEndpoint$data = WebhookEndpointRow_webhookEndpoint;
export type WebhookEndpointRow_webhookEndpoint$key = {
    readonly " $data"?: WebhookEndpointRow_webhookEndpoint$data;
    readonly " $fragmentRefs": FragmentRefs<"WebhookEndpointRow_webhookEndpoint">;
};



const node: ReaderFragment = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "WebhookEndpointRow_webhookEndpoint",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "enabled",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "url",
            "storageKey": null
        }
    ],
    "type": "WebhookEndpoint",
    "abstractKey": null
} as any;
(node as any).hash = '4e300e7e85b14d6636e900a2f8dbeef5';
export default node;
